<template>
   <b-link class="brand-logo " :href="'/'" >
      <img :src="logo" :alt="appName"  />
   </b-link>
</template>

<script setup>

import { $themeConfig } from '@themeConfig'
import useAppConfig from '@/store/app-config';
import useUtils from '@composables/useUtils';
import logo_fondo_claro from '@images/logos/logo_fondo_claro.png';
import logo_fondo_oscuro from '@images/logos/logo_fondo_oscuro.png';
import logo_fondo_claro_completo from '@images/logos/logo_fondo_claro_completo.svg';
import logo_short_fondo_oscuro from '@images/logos/logo_short_fondo_oscuro.svg';
import logo_short_fondo_claro from '@images/logos/logo_short_fondo_claro.svg';

const props = defineProps({
   url:{
      type:[Object,String],
      required:false,
      default:() => ({name:'welcome'})
   },

   infochannel:{
      type:Boolean,
      default:false
   },

   white:{
      type:Boolean,
      default:false
   },

   completo: {
      type: Boolean,
      default: false
   },
   
   short:{
      type:Boolean,
      default:false
   }


});

const {
   isScreenMovil
} = useUtils();

const app_config_store = useAppConfig();
const {white,completo,short} = toRefs(props);
const { skin } = toRefs(app_config_store.layout)
const { appName, appLogoImage, applogoImageWhite } = $themeConfig.app;


const logo = computed(() => {
   if(short.value && white.value) return logo_short_fondo_oscuro;
   if(short.value && !white.value) return logo_short_fondo_claro;

   // if (isScreenMovil.value) return logo_short_fondo_oscuro; 
   if (white.value) return logo_fondo_oscuro;
   return logo_fondo_claro;
})

</script>

<style lang="scss" scoped>
   
   .brand-logo{
      img{
         max-width: 180px; 
         max-height: 70px;
      }
   }

</style>

